import { User } from '@src/main/modules/user/domain/user.interface';
import { UserRepository } from '@src/main/modules/user/domain/user.repository';

export const findUserById = async (repository: UserRepository, id: string): Promise<User> =>
  await repository.findById(id);
